// The config endpoint describes every field as { type, value, title }, so the
// form is built from the response. The only fields defined here are the ones
// whose choices the response cannot describe.

export const YES_NO_OPTIONS = [
  { label: "Please Select", value: "" },
  { label: "Yes", value: true },
  { label: "No", value: false },
];

export const FIXED_OPTIONS = {
  currency: ["", "$", "£", "R", "¥", "₾", "₫", "€", "Dh"].map((v) => ({
    label: v || "Select Currency",
    value: v,
  })),
  temperatureUnit: [
    { label: "Please Select", value: "" },
    { label: "Fahrenheit (F)", value: "F" },
    { label: "Celsius (C)", value: "C" },
  ],
  speedUnit: [
    { label: "Please Select", value: "" },
    { label: "Miles per hour (mph)", value: "mph" },
    { label: "Kilometers per hour (kph)", value: "kph" },
  ],
  measurementSystem: [
    { label: "Please Select", value: "" },
    { label: "Imperial", value: "imperial" },
    { label: "Metric", value: "metric" },
  ],
};

// Timezone is a dropdown too, but its options come from the timezones store.
const SELECT_KEYS = new Set(["timezone", ...Object.keys(FIXED_OPTIONS)]);

const INPUT_TYPES = {
  number: "number",
  string: "text",
};

const isConfigField = (field) => {
  return field !== null && typeof field === "object" && "value" in field;
};

export const isSelectField = (key, field) => {
  return field.type === "boolean" || SELECT_KEYS.has(key);
};

export const inputTypeFor = (field) => {
  return INPUT_TYPES[field.type] ?? "text";
};

// Keep the order the endpoint returns the fields in.
export const configFieldEntries = (config) => {
  return Object.entries(config ?? {}).filter(([, field]) =>
    isConfigField(field)
  );
};
